<template>
  <section>
    <h2 class="h3 mb-3 mt-5">Auto-Generate Program</h2>

    <form-alert :message="alertMessage" :type="alertType" />

    <div class="col-lg-4 px-0">
      <f-color
        id="programColor"
        label="Select accent color"
        :value="value.program_color"
        :disabled="busy"
        @input="onColorChange"
      />

      <div v-if="value.program" class="mb-2">
        <label class="d-block mb-1">Current Program</label>
        <a :href="value.program" target="_blank" rel="noopener">View uploaded file</a>
      </div>

      <div v-if="value.secretary_program" class="mb-2">
        <label class="d-block mb-1">Program under review</label>
        <a :href="value.secretary_program" target="_blank" rel="noopener">View uploaded file</a>
      </div>

      <div v-if="value.temporary_program" class="mb-3">
        <label class="d-block mb-1">Auto-Generated Preview</label>
        <a :href="value.temporary_program" target="_blank" rel="noopener">View generated program</a>
      </div>

      <div class="d-flex flex-wrap">
        <button
          type="button"
          class="btn btn-outline-primary mr-2 mb-2"
          :disabled="busy"
          @click="$emit('generate')"
        >
          <span v-if="generating" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />
          Review auto-generated Program
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2"
          :disabled="busy"
          @click="$emit('approve')"
        >
          <span v-if="approving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />
          Submit Program
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import FormAlert from '@/components/FormAlert'
import FColor from '@/components/FormFields/FColor'

export default {
  name: 'AutoGenerateProgramSection',
  components: { FormAlert, FColor },
  props: {
    value: { type: Object, required: true },
    generating: { type: Boolean, default: false },
    approving: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    alertMessage: { type: String, default: null },
    alertType: { type: String, default: 'warning' }
  },
  methods: {
    onColorChange(color) {
      this.$emit('input', { ...this.value, program_color: color })
      this.$emit('color-change', color)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Drafts/AutoGenerateProgramSection.vue